;(function(Flickity) {
	document.addEventListener('DOMContentLoaded', function() {
    const heroContainers = document.querySelectorAll('.ppq__container');

    // Function to set cards flippable on load
    function setCardsFlippable() {
      // Use IntersectionObserver to trigger cards flip on load
      const section = document.querySelector(".pdp-product-about .wines-wrapper");

      if (section) {
        const observer = new IntersectionObserver(
          (entries, observer) => {
            if (entries[0].isIntersecting) {
              cards.forEach((card) => {
                if (card.classList.contains("is-selected")) {
                  card.classList.add("flipped");
                  setTimeout(() => {
                    card.classList.remove("flipped");
                  }, 2000);
                }
              });
              observer.disconnect(); // Stop observing after running once
            }
          }, {
            threshold: 0.5
          } // Runs when 50% of the section is visible
        );
      
        observer.observe(section);
      }
    }

    const cards = document.querySelectorAll(".pdp-product-about .wines-wrapper .wines-card");

    // Allow manual flipping on click
    cards.forEach((card) => {
      card.addEventListener("click", () => {
        card.classList.toggle("flipped");
      });
    });

    // Function to fetch the wines from the Shopify API using data-sku attribute
		window.fetchWines = function() {
      let storefrontToken = document.querySelector('.pdp-product-about')?.dataset.token || '';
      // Fetch Wine Data Only If Token Exists
      if (!storefrontToken) return;

			const wineCards = document.querySelectorAll('.wine-carousel .wines-card');
			const skus = Array.from(wineCards).map(wineCard => wineCard.getAttribute('data-sku'));
			if (skus.length === 0) return;
			const query = `{
            products(query: "${skus.join(" OR ")}", first: ${skus.length}) {
                edges {
                    node {
                        title
                        handle
                        description
                        images(first: 1) { edges { node { url } } }
                        variants(first: 10) { edges { node { sku } } }
                        metafields(
                            identifiers: [
                                {namespace: "custom", key: "pairs_well_with_linked_to_metaobjects"}, 
                                {namespace: "custom", key: "tasting_notes_metaobjects"}, 
                                {namespace: "custom", key: "alcohol_percent"}, 
                                {namespace: "custom", key: "sweetness"}, 
                                {namespace: "custom", key: "body"}, 
                                {namespace: "custom", key: "varietal"}
                            ]
                        ) {
                            key
                            value
                            references(first: 10) {
                                nodes {
                                    ... on Metaobject {
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage { image { url } }
                                            }
                                        }
                                        title: field(key: "title") { value }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }`;
			fetch('/api/2024-04/graphql.json', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					'X-Shopify-Storefront-Access-Token': storefrontToken,
				},
				body: JSON.stringify({
					query
				}),
			}).then(res => res.json()).then(({
				data
			}) => {
				const products = data.products.edges;
				wineCards.forEach(wineCard => {
					const sku = wineCard.getAttribute('data-sku');
					const product = products.find(({
						node
					}) => node.variants.edges.some(variant => variant.node.sku === sku))?.node;
					if (!product) return;
					const productUrl = `/products/${product.handle}`;
					wineCard.querySelector('.wines-card__title').innerText = product.title;
					wineCard.querySelector('.wines-card__image img').src = product.images.edges[0]?.node.url || '';
          // Handle Description
          wineCard.querySelectorAll('.wines-card__description').forEach(description => {
            let desc = product.description;
            let truncatedDesc = desc.length > 180 ? desc.slice(0, 180) + "..." : desc;
            description.innerText = truncatedDesc;
          });
					// Handle Badges
					const metafieldMap = {
						'sweetness': '.wines-card__badge.sweetness',
						'body': '.wines-card__badge.body',
						'alcohol_percent': '.wines-card__badge.alcohol-percent'
					};
					Object.keys(metafieldMap).forEach(key => {
						const value = product.metafields.find(m => m?.key === key)?.value;
						wineCard.querySelectorAll(metafieldMap[key]).forEach(element => {
							element.innerText = key === 'alcohol_percent' ? `${value}% Alc./Vol` : value;
						});
					});
					// Function to handle metaobjects dynamically
					function handleMetaObjects(metaKey, wrapperClass, textClass, itemClass, imageClass, typeClass) {
						const meta = product.metafields.find(m => m?.key === metaKey);
						const wrapper = wineCard.querySelector(wrapperClass);
						const textElement = wineCard.querySelector(textClass);
						if (meta) {
							meta.references.nodes.slice(0, 4).forEach(metaObject => {
								const url = metaObject.image.reference.image.url;
								const keyName = metaObject.title.value;
								const item = document.createElement('div');
								item.classList.add(itemClass);
								const image = document.createElement('img');
								image.src = url;
								image.classList.add(imageClass);
								const type = document.createElement('div');
								type.classList.add(typeClass);
								type.textContent = keyName;
								item.appendChild(image);
								item.appendChild(type);
								wrapper.appendChild(item);
							});
						} else {
							textElement.classList.add('hide');
							wrapper.classList.add('hide');
						}
					}
					// Handle Pairing
					handleMetaObjects('pairs_well_with_linked_to_metaobjects', '.wines-card__pairing-wrapper', '.wines-card__pairing', 'wines-card__pairing-item', 'wines-card__pairing-image', 'wines-card__pairing-type');
					// Handle Tasting Notes
					handleMetaObjects('tasting_notes_metaobjects', '.wines-card__tasting-notes-wrapper', '.wines-card__tasting-notes', 'wines-card__tasting-notes-item', 'wines-card__tasting-notes-image', 'wines-card__tasting-notes-type');
				});
				// Initialize Flickity and Flip Cards on load
				initFlickity();
			}).catch(error => console.error("Failed to fetch product data:", error));
		}

    // Function to initialize Flickity
    function initFlickity() {
      document.querySelectorAll('.wines-wrapper').forEach((slider) => {
        let flktyInstance = null;
    
        const getFlickityOptions = () => ({
          initialIndex: '.is-initial-select',
          groupCells: 1,
          cellAlign: 'center',
          pageDots: slider.children.length > 1 && window.innerWidth <= 768,
          prevNextButtons: slider.children.length > 1 && window.innerWidth > 768,
          on: {
            ready: () => {
              setCardsFlippable(); // Ensure function runs after Flickity is ready
            }
          }        
        });
    
        const updateFlickity = () => {
          if (!flktyInstance) {
            flktyInstance = new Flickity(slider, getFlickityOptions());
          } else {
            flktyInstance.destroy();
            flktyInstance = new Flickity(slider, getFlickityOptions());
          }
        };        
    
        updateFlickity();
    
        let lastWidth = window.innerWidth;
        window.addEventListener('resize', () => {
          const currentWidth = window.innerWidth;
          if (currentWidth !== lastWidth) {
            lastWidth = currentWidth;
            updateFlickity();
          }
        });  
      });
    }

    // If there are no hero containers (PPQ template), run the fetchWines function on load (Packs PDP)
    // This is to ensure that the fetchwines function is triggered only once on the PPQ template
    if (heroContainers.length === 0) {
      fetchWines();
    }  
	});
})(themeVendor.Flickity)